import { render, staticRenderFns } from "./TenanciesContactCard.vue?vue&type=template&id=6a4e97d8&scoped=true"
import script from "./TenanciesContactCard.vue?vue&type=script&lang=js"
export * from "./TenanciesContactCard.vue?vue&type=script&lang=js"
import style0 from "./TenanciesContactCard.vue?vue&type=style&index=0&id=6a4e97d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e97d8",
  null
  
)

export default component.exports